module.exports = __webpack_public_path__ + "static/NewsLatterBg-f08537e8e695ae093046fa1935049d5c.jpg";